import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PortalLeadNode, PortalOrderNode } from '@app/services/api/api.types';

@Component({
  selector: 'flight-info',
  templateUrl: './flight-info.component.html',
  styleUrls: ['./flight-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightInfoComponent {
  @Input() title: string;
  @Input() showBack: boolean;
  @Input() portalLead?: PortalLeadNode;
  @Input() portalOrder?: PortalOrderNode;

  @Output() back = new EventEmitter();

  get departureAirportCityName() {
    return (
      this.portalLead?.firstTrip?.departureAirport?.cityName ||
      this.portalOrder?.flightItineraries[0].departureAirport.cityName
    );
  }

  get arrivalAirportCityName() {
    return (
      this.portalLead?.firstTrip?.arrivalAirport?.cityName ||
      this.portalOrder?.flightItineraries[0].arrivalAirport.cityName
    );
  }

  get departureAt() {
    return (
      this.portalLead?.firstTrip?.departureAt || this.portalOrder?.flightItineraries[0].departureAt
    );
  }

  get passengerCount() {
    return this.portalLead?.firstTrip?.passengerCount || this.portalOrder?.totalPassengers;
  }
}
